import React from 'react';
import Row from '../../../../components/Row';
import Col from '../../../../components/Col';
import SignatureCanvas from '../../../../components/SignatureCanvas/SignatureCanvas';
import Callout from 'src/components/InformationCallout/Callout';
import SectionHeading from 'src/components/SectionHeading/SectionHeading';
import { variables } from 'src/Tenants';
import { KeyHandoffSignature } from 'src/SharedCustomHooks/UseSuiteActions/useKeyHandoffSubmission';
import './key-handoff-signatures.scss';

type Signer = 'internal' | 'homeOwner';

interface KeyHandoffSignaturesProps {
  internalSignerName: string;
  primaryHomeOwnerName: string;
  internalSignature: KeyHandoffSignature | null;
  homeOwnerSignature: KeyHandoffSignature | null;
  primaryContact: any;
  user: any;
  onSign: (image: any, signType: any, signer: Signer) => void;
  onRemoveInternal: () => void;
  onRemoveHomeOwner: () => void;
}

const KeyHandoffSignatures = ({
  internalSignerName,
  primaryHomeOwnerName,
  internalSignature,
  homeOwnerSignature,
  primaryContact,
  user,
  onSign,
  onRemoveInternal,
  onRemoveHomeOwner,
}: KeyHandoffSignaturesProps) => {
  const hasHomeOwner: boolean = Boolean(primaryContact && primaryContact.id);

  const missingHomeOwnerMessage: string = `This ${variables.Suite.toLowerCase()} has no primary home owner assigned, so there's 
  no one to sign the home owner portion of the key pickup. Go back to the ${variables.Suite.toLowerCase()}, 
  add a primary home owner under the People tab, then return here to complete the handoff.`;

  return (
    <div className="key-handoff-signatures">
      <div className="signatures-panel">
        <SectionHeading title="Signatures" />
        <Row>
          <Col xs="12" md="6">
            <Row mdCenter>
              <Col md="8">
                <h4>{internalSignerName} Internal Team Member Signature</h4>
              </Col>
            </Row>
            <SignatureCanvas
              type={'keyhandoff'}
              onInsert={(url: any, signType: any) =>
                onSign(url, signType, 'internal')
              }
              signed={internalSignature?.signature || ''}
              signType={internalSignature?.signType || ''}
              remove={onRemoveInternal}
              firstName={user?.firstName || ''}
              lastName={user?.lastName || ''}
              typeOfSign={'keyhandoff'}
            />
          </Col>

          {hasHomeOwner ? (
            <Col xs="12" md="6">
              <Row mdCenter>
                <Col md="8">
                  <h4>{primaryHomeOwnerName} Home Owner Signature</h4>
                </Col>
              </Row>
              <SignatureCanvas
                type={'keyhandoff'}
                onInsert={(url: any, signType: any) =>
                  onSign(url, signType, 'homeOwner')
                }
                signed={homeOwnerSignature?.signature || ''}
                signType={homeOwnerSignature?.signType || ''}
                remove={onRemoveHomeOwner}
                firstName={primaryContact?.firstname || ''}
                lastName={primaryContact?.lastname || ''}
                typeOfSign={'keyhandoff'}
              />
            </Col>
          ) : (
            <Col xs="12" md="6">
              <div className="missing-home-owner">
                <Callout
                  variant="warning"
                  title={`No primary home owner on this ${variables.Suite.toLowerCase()}`}
                  subtitle={missingHomeOwnerMessage}
                />
              </div>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

export default KeyHandoffSignatures;
